import { ApiResponse } from '../../../../constants/types';
import {
  StudentProfile,
  PutStudentBasicInfoRequest,
  PutStudentGuardianInfoRequest,
  PutStudentPasswordRequest,
} from '../../../../constants/types/student/profile/type';
import instance from '../../../axios/utils.ts/instance';

//============================== 학생 정보 조회 ==============================
/**
 * 학생 본인 정보 조회
 * @returns
 */
export const getStudentProfile = async () => {
  const response =
    await instance.get<ApiResponse<StudentProfile>>('/v1/user/student');
  return response.data.data;
};

//============================== 기본 정보 관리 ==============================
/**
 * 학생 본인 기본 정보 수정
 * @description 조회한 값과 비교해 바뀐 항목만 보낸다. (이름은 수정할 수 없어 보내지 않는다)
 * @param request 바뀐 기본 정보 항목
 */
export const putStudentBasicInfo = async (
  request: PutStudentBasicInfoRequest,
) => {
  const result = await instance.put<ApiResponse<StudentProfile>>(
    '/v1/user/student/basic-info',
    request,
  );
  return result.data.data;
};

//============================== 보호자 정보 관리 ==============================
/**
 *
 * @description 학생 보호자(법정대리인) 정보를 수정합니다.
 * - 요청: guardianInfo는 객체 1개입니다 (배열 아님 - 배열 전송 시 400). 예: { "guardianInfo": { "name": "보호자", "phone": "01012341234", "gender": "FEMALE", "birthday": "1997-01-03", "countryCode": "+82", "agreementPersonalInfo": true } }
 * - countryCode('+'와 1~3자리 숫자)와 agreementPersonalInfo는 필수입니다. (빠지면 400)
 * - 보호자를 삭제할 때는 null을 보냅니다. 예: { "guardianInfo": null }
 * - 처리: 처리: 저장 시 교사/어드민 화면의 보호자 목록(parents)에도 같은 내용이 동기화됩니다 (같은 성별 유형 행 갱신/추가).
 * @param guardianInfo 저장할 보호자 정보. 삭제 시 null
 */
export const putStudentGuardianInfo = async (
  guardianInfo: PutStudentGuardianInfoRequest | null,
) => {
  const result = await instance.put<ApiResponse<StudentProfile>>(
    '/v1/user/student/parent-info',
    { guardianInfo },
  );
  return result.data.data;
};

//============================== 클래스 코드 관리 ==============================
/**
 * 학생 본인 클래스 코드 추가
 * @description 응답으로 갱신된 내 정보(클래스 목록 포함)를 돌려준다.
 * @param classId 클래스 코드
 */
export const putStudentClassCode = async (classId: string) => {
  const result = await instance.put<ApiResponse<StudentProfile>>(
    '/v1/user/student/class-code',
    { classIds: [classId] },
  );
  return result.data.data;
};

/**
 * 학생 본인 클래스 코드 삭제
 * @description 응답으로 갱신된 내 정보(클래스 목록 포함)를 돌려준다.
 * @param classId 클래스 코드
 */
export const deleteStudentClassCode = async (classId: string) => {
  const result = await instance.delete<ApiResponse<StudentProfile>>(
    `/v1/user/student/class-code/${classId}`,
  );
  return result.data.data;
};

//============================== 비밀번호 변경 ==============================
/**
 * 학생 본인 비밀번호 변경
 * @description 비밀번호 변경에 성공하면 새 비밀번호로 로그인할 수 있습니다.
 * @param data 변경할 비밀번호 정보
 */
export const putStudentPassword = async (data: PutStudentPasswordRequest) => {
  const result = await instance.patch('/v1/mypage/user/password', data);
  return result.data.data;
};
